export const EmailMutationKey = {
    SEND_TEST_EMAIL: 'SEND_TEST_EMAIL',
} as const;

export const ReviewQueryKey = {
    READY_TO_BE_LAUNCHED_REVIEWS: 'READY_TO_BE_LAUNCHED_REVIEWS',
    ONGOING_REVIEWS: 'ONGOING_REVIEWS',
    PAST_REVIEWS: 'PAST_REVIEWS',
    READY_TO_BE_LAUNCHED_REVIEWS_PAGED: 'READY_TO_BE_LAUNCHED_REVIEWS_PAGED',
    ONGOING_REVIEWS_PAGED: 'ONGOING_REVIEWS_PAGED',
    PAST_REVIEWS_PAGED: 'PAST_REVIEWS_PAGED',
    REVIEW_AUDIENCE: 'REVIEW_AUDIENCE',
    CYCLE_INSTANCE: 'CYCLE_INSTANCE',
} as const;

export const ReviewMutationKey = {
    SEND_REMINDER: 'SEND_REMINDER',
    UPDATE_REVIEW_AUDIENCE: 'UPDATE_REVIEW_AUDIENCE',
    UPDATE_REVIEW_EVALUATOR_SELECTION: 'UPDATE_REVIEW_EVALUATOR_SELECTION',
} as const;

export const ReviewQuestionnaireQueryKey = {
    REVIEW_QUESTIONNAIRE: 'REVIEW_QUESTIONNAIRE',
} as const;

export const ReviewQuestionnaireMutationKey = {
    REVIEW_QUESTIONNAIRE: 'REVIEW_QUESTIONNAIRE',
} as const;

export const ReviewQuestionQueryKey = {
    REVIEW_QUESTION: 'REVIEW_QUESTION',
} as const;

export const ReviewQuestionMutationKey = {
    REVIEW_QUESTION: 'REVIEW_QUESTION',
} as const;

export const ReviewQuestionAnswerMutationKey = {
    REVIEW_QUESTION_ANSWER: 'REVIEW_QUESTION_ANSWER',
} as const;

export const ReviewAnswerQueryKey = {
    REVIEW_ANSWER: 'REVIEW_ANSWER',
} as const;

export const ReviewInstanceQueryKey = {
    REVIEW_INSTANCE_RESULTS: 'REVIEW_INSTANCE_RESULTS',
    REVIEW_INSTANCE: 'REVIEW_INSTANCE',
} as const;

export const PostReviewResultsQueryKey = {
    COMPETENCY_RESULTS: 'POST_REVIEW_COMPETENCY_RESULTS',
    SUMMARY: 'POST_REVIEW_SUMMARY',
    NOTES: 'POST_REVIEW_NOTES',
    PORTRAIT_META: 'POST_REVIEW_PORTRAIT_META',
    COMPETENCY_HISTORY: 'POST_REVIEW_COMPETENCY_HISTORY',
} as const;

export const PostReviewResultsMutationKey = {
    UPDATE_COMPETENCY_PROFICIENCY: 'UPDATE_COMPETENCY_PROFICIENCY',
    UPDATE_PERFORMANCE_SCORE: 'UPDATE_PERFORMANCE_SCORE',
    UPDATE_EVALUATION_DATE: 'UPDATE_EVALUATION_DATE',
} as const;

export const PostReviewMeetingQueryKey = {
    MEETING_STATUS: 'POST_REVIEW_MEETING_STATUS',
    MEETING_AGENDA: 'POST_REVIEW_MEETING_AGENDA',
    MEETING_TRANSCRIPT: 'POST_REVIEW_MEETING_TRANSCRIPT',
} as const;

export const PostReviewMeetingMutationKey = {
    COMPLETE_MEETING: 'COMPLETE_MEETING',
    UNCOMPLETE_MEETING: 'UNCOMPLETE_MEETING',
    UPDATE_MEETING_AGENDA: 'UPDATE_MEETING_AGENDA',
    UPLOAD_MEETING_TRANSCRIPT: 'UPLOAD_MEETING_TRANSCRIPT',
    DELETE_MEETING_TRANSCRIPT: 'DELETE_MEETING_TRANSCRIPT',
} as const;

export const CommentReplyQueryKey = {
    COMMENT_REPLIES: 'COMMENT_REPLIES',
} as const;

export const CommentReplyMutationKey = {
    CREATE_COMMENT_REPLY: 'CREATE_COMMENT_REPLY',
} as const;

export const DirectoryQueryKey = {
    COMPANY_INFORMATION: 'COMPANY_INFORMATION',
    COMPANY_EMPLOYEES: 'COMPANY_EMPLOYEES',
    COMPANY_USERS: 'COMPANY_USERS',
    USERS_BY_IDS: 'USERS_BY_IDS',
    USER_BY_ID: 'USER_BY_ID',
    USER_PERMISSIONS: 'USER_PERMISSIONS',
    DIRECT_REPORTS: 'DIRECT_REPORTS',
} as const;

export const CycleInstanceQueryKey = {
    EMPLOYEES: 'EMPLOYEES',
    POTENTIAL_REVIEWERS: 'POTENTIAL_REVIEWERS',
    CYCLE_INSTANCE: 'CYCLE_INSTANCE',
} as const;

export const ReviewTemplateQueryKey = {
    TEMPLATE: 'TEMPLATE',
    TEMPLATE_QUESTIONS: 'TEMPLATE_QUESTIONS',
    PREVIEW_QUESTIONS: 'TEMPLATE_PREVIEW_QUESTIONS',
} as const;

export const ReviewTemplateMutationKey = {
    UPDATE_TEMPLATE_CARD: 'UPDATE_TEMPLATE_CARD',
} as const;

export const ConfigurationQueryKey = {
    CONFIGURATION: 'CONFIGURATION',
} as const;

export const ScheduleQueryKey = {
    SCHEDULE: 'SCHEDULE',
} as const;

export const ScheduleMutationKey = {
    SEND_TEST_EMAIL: 'SEND_TEST_EMAIL',
    LAUNCH_EVALUATION: 'LAUNCH_EVALUATION',
    UPDATE_SCHEDULE: 'UPDATE_SCHEDULE',
} as const;

export const CycleQuestionnaireQueryKey = {
    CYCLE_QUESTIONNAIRE: 'CYCLE_QUESTIONNAIRE',
} as const;

export const CycleScheduleQueryKey = {
    CYCLE_SCHEDULE: 'CYCLE_SCHEDULE',
} as const;

export const CycleEvaluationQueryKey = {
    CYCLE_EVALUATION: 'CYCLE_EVALUATION',
    CYCLE_EVALUATION_LIST: 'CYCLE_EVALUATION_LIST',
    CYCLE_AUDIENCE: 'CYCLE_AUDIENCE',
    SENT_CYCLES: 'SENT_CYCLES',
    SURVEYS: 'SURVEYS',
    MANAGER_LAUNCH_STATUS: 'MANAGER_LAUNCH_STATUS',
    PROGRESS_TRACKING_SUMMARY: 'PROGRESS_TRACKING_SUMMARY',
} as const;

export const CycleEvaluationGroupQueryKey = {
    CYCLE_EVALUATION_GROUP: 'CYCLE_EVALUATION_GROUP',
} as const;

export const CycleMilestoneQueryKey = {
    CYCLE_MILESTONE: 'CYCLE_MILESTONE',
} as const;

export const CycleAudienceMutationKey = {
    UPDATE_CYCLE_AUDIENCE: 'UPDATE_CYCLE_AUDIENCE',
} as const;

export const CycleAudienceQueryKey = {
    GET_CYCLE_AUDIENCE: 'GET_CYCLE_AUDIENCE',
} as const;

export const CompetencyQueryKey = {
    COMPETENCIES: 'COMPETENCIES',
    COMPETENCY: 'COMPETENCY',
    COMPETENCY_GROUPS: 'COMPETENCY_GROUPS',
    COMPETENCY_IMPACT: 'COMPETENCY_IMPACT',
} as const;

export const CompetencyCatalogQueryKey = {
    COMPETENCY_CATALOG: 'COMPETENCY_CATALOG',
} as const;

export const EmployeeCompetencyQueryKey = {
    EFFECTIVE: 'EMPLOYEE_COMPETENCY_EFFECTIVE',
    INDIVIDUAL_EMPLOYEES: 'EMPLOYEE_COMPETENCY_INDIVIDUAL_EMPLOYEES',
} as const;

export const ProficiencyLevelQueryKey = {
    PROFICIENCY_LEVELS: 'PROFICIENCY_LEVELS',
} as const;

export const ProfileAssignmentQueryKey = {
    EMPLOYEES: 'PROFILE_ASSIGNMENT_EMPLOYEES',
    ASSIGNMENTS: 'PROFILE_ASSIGNMENT_ASSIGNMENTS',
    STATISTICS: 'PROFILE_ASSIGNMENT_STATISTICS',
    ROSTER: 'PROFILE_ASSIGNMENT_ROSTER',
} as const;

export const CompetencyMutationKey = {
    CREATE_COMPETENCY: 'CREATE_COMPETENCY',
    UPDATE_COMPETENCY: 'UPDATE_COMPETENCY',
    DELETE_COMPETENCY: 'DELETE_COMPETENCY',
} as const;

export const CompetencyGroupQueryKey = {
    COMPETENCY_GROUPS: 'COMPETENCY_GROUPS',
    COMPETENCY_GROUP: 'COMPETENCY_GROUP',
    LIBRARY_GROUPS: 'COMPETENCY_LIBRARY_GROUPS',
    GROUPS: 'COMPETENCY_GROUPS',
} as const;

export const CompetencyGroupMutationKey = {
    CREATE_COMPETENCY_GROUP: 'CREATE_COMPETENCY_GROUP',
    UPDATE_COMPETENCY_GROUP: 'UPDATE_COMPETENCY_GROUP',
    DELETE_COMPETENCY_GROUP: 'DELETE_COMPETENCY_GROUP',
} as const;

export const CompetenciesQueryKey = {
    PROFICIENCY_LEVELS: 'PROFICIENCY_LEVELS',
    COMPETENCY_GROUPS: 'COMPETENCY_GROUPS',
    COMPETENCY_TRANSLATIONS: 'COMPETENCY_TRANSLATIONS',
    COMPETENCY_TRANSLATION_GROUP_SUMMARIES: 'COMPETENCY_TRANSLATION_GROUP_SUMMARIES',
    COMPETENCY_TRANSLATION_GROUP: 'COMPETENCY_TRANSLATION_GROUP',
} as const;

export const CompetencyQuestionQueryKey = {
    COMPETENCY_QUESTIONS: 'COMPETENCY_QUESTIONS',
} as const;

export const CompetencyQuestionMutationKey = {
    CREATE_COMPETENCY_QUESTION: 'CREATE_COMPETENCY_QUESTION',
    UPDATE_COMPETENCY_QUESTION: 'UPDATE_COMPETENCY_QUESTION',
    DELETE_COMPETENCY_QUESTION: 'DELETE_COMPETENCY_QUESTION',
    UPDATE_COMPETENCY_QUESTIONNAIRE: 'UPDATE_COMPETENCY_QUESTIONNAIRE',
    MOVE_COMPETENCY_QUESTION: 'MOVE_COMPETENCY_QUESTION',
} as const;

export const CompetencyProfileAssignmentQueryKey = {
    ASSIGNMENTS: 'COMPETENCY_PROFILE_ASSIGNMENTS',
    PROFILES: 'COMPETENCY_PROFILE_ASSIGNMENT_PROFILES',
} as const;

export const CompetencyProfileAssignmentMutationKey = {
    ASSIGN: 'ASSIGN_COMPETENCY_PROFILE',
    BULK_ASSIGN: 'BULK_ASSIGN_COMPETENCY_PROFILE',
    REMOVE: 'REMOVE_COMPETENCY_PROFILE_ASSIGNMENT',
} as const;

export const CompetencyProfileQueryKey = {
    PROFILES: 'COMPETENCY_PROFILES',
    PROFILE: 'COMPETENCY_PROFILE',
    COMPETENCY_PROFILES: 'COMPETENCY_PROFILES',
} as const;

export const CompetencyProfileMutationKey = {
    CREATE_PROFILE: 'CREATE_COMPETENCY_PROFILE',
    UPDATE_PROFILE: 'UPDATE_COMPETENCY_PROFILE',
    DELETE_PROFILE: 'DELETE_COMPETENCY_PROFILE',
    ADD_COMPETENCIES: 'ADD_COMPETENCIES_TO_PROFILE',
    REMOVE_COMPETENCY: 'REMOVE_COMPETENCY_FROM_PROFILE',
} as const;

export const CompetencyAssignmentQueryKey = {
    ASSIGNMENTS: 'COMPETENCY_ASSIGNMENTS',
} as const;

export const CompetencyAssignmentMutationKey = {
    ASSIGN: 'ASSIGN_COMPETENCY',
} as const;

export const CompetencyGroupAssignmentQueryKey = {
    ASSIGNMENTS: 'COMPETENCY_GROUP_ASSIGNMENTS',
} as const;

export const CompetencyGroupAssignmentMutationKey = {
    BULK_ASSIGN: 'BULK_ASSIGN_COMPETENCY_GROUP',
} as const;

export const CompanyValueQueryKey = {
    COMPANY_VALUES: 'COMPANY_VALUES',
    COMPANY_VALUE: 'COMPANY_VALUE',
    COMPANY_VALUE_IMPACT: 'COMPANY_VALUE_IMPACT',
} as const;

export const CompanyValueMutationKey = {
    CREATE_COMPANY_VALUE: 'CREATE_COMPANY_VALUE',
    UPDATE_COMPANY_VALUE: 'UPDATE_COMPANY_VALUE',
    DELETE_COMPANY_VALUE: 'DELETE_COMPANY_VALUE',
    TOGGLE_STATUS: 'TOGGLE_COMPANY_VALUE_STATUS',
} as const;

export const PillarQueryKey = {
    PILLARS: 'PILLARS',
    PILLAR: 'PILLAR',
    OBJECTIVE_ALIGNMENT: 'PILLAR_OBJECTIVE_ALIGNMENT',
} as const;

export const PillarMutationKey = {
    CREATE_PILLAR: 'CREATE_PILLAR',
    UPDATE_PILLAR: 'UPDATE_PILLAR',
    DELETE_PILLAR: 'DELETE_PILLAR',
    TOGGLE_STATUS: 'TOGGLE_PILLAR_STATUS',
} as const;

export const CompanyValueQuestionQueryKey = {
    COMPANY_VALUE_QUESTIONS: 'COMPANY_VALUE_QUESTIONS',
} as const;

export const CompanyValueQuestionMutationKey = {
    CREATE_COMPANY_VALUE_QUESTION: 'CREATE_COMPANY_VALUE_QUESTION',
    UPDATE_COMPANY_VALUE_QUESTION: 'UPDATE_COMPANY_VALUE_QUESTION',
    UPDATE_COMPANY_VALUE_QUESTION_TRANSLATIONS: 'UPDATE_COMPANY_VALUE_QUESTION_TRANSLATIONS',
    DELETE_COMPANY_VALUE_QUESTION: 'DELETE_COMPANY_VALUE_QUESTION',
    TOGGLE_COMPANY_VALUE_QUESTION_ACTIVE: 'TOGGLE_COMPANY_VALUE_QUESTION_ACTIVE',
    REORDER_COMPANY_VALUE_QUESTIONS: 'REORDER_COMPANY_VALUE_QUESTIONS',
} as const;

export const ManagerAssessmentQueryKey = {
    EVALUATION_PERIODS: 'EVALUATION_PERIODS',
    ASSESSMENT_TEMPLATES: 'ASSESSMENT_TEMPLATES',
    TEMPLATE_QUESTIONS: 'TEMPLATE_QUESTIONS',
    COMPETENCY_HISTORY: 'COMPETENCY_HISTORY',
    UPDATE_PERFORMANCE_SCORE: 'UPDATE_PERFORMANCE_SCORE',
    PORTRAIT_META: 'PORTRAIT_META',
    GENERATE_AI_SUMMARY: 'GENERATE_AI_SUMMARY',
    AI_SUMMARY: 'AI_SUMMARY',
    ASSESSMENT_SCORE: 'ASSESSMENT_SCORE',
    COMPETENCY_RESULTS: 'COMPETENCY_RESULTS',
} as const;

export const PerformanceProfileQueryKey = {
    PERFORMANCE_SCORE: 'PERFORMANCE_SCORE',
    PERFORMANCE_TREND: 'PERFORMANCE_TREND',
    EVALUATION_PERIODS: 'PERFORMANCE_PROFILE_EVALUATION_PERIODS',
    COMPETENCY_ASSIGNMENT: 'PERFORMANCE_COMPETENCY_ASSIGNMENT',
    AVAILABLE_COMPETENCIES: 'PERFORMANCE_AVAILABLE_COMPETENCIES',
    SELF_ASSESSMENTS: 'SELF_ASSESSMENTS',
    EVALUATION_360: 'EVALUATION_360',
    MANAGER_ASSESSMENTS: 'MANAGER_ASSESSMENTS',
    SKILLSET_ASSESSMENT: 'SKILLSET_ASSESSMENT',
    SKILLSET_EVALUATORS: 'SKILLSET_EVALUATORS',
    ASSESSMENT_HISTORY: 'ASSESSMENT_HISTORY',
    PROFICIENCY_LEVELS: 'PROFICIENCY_LEVELS',
    SKILL_PROFICIENCY: 'SKILL_PROFICIENCY',
    COMPETENCY_HISTORY: 'COMPETENCY_HISTORY',
    GROWTH: 'PERFORMANCE_PROFILE_GROWTH',
    MY_EVOLUTION: 'PERFORMANCE_PROFILE_MY_EVOLUTION',
    CAREER_ASPIRATION: 'PERFORMANCE_PROFILE_CAREER_ASPIRATION',
    CAREER_ASPIRATION_HISTORY: 'PERFORMANCE_PROFILE_CAREER_ASPIRATION_HISTORY',
    EMPLOYEE_NOTES: 'PERFORMANCE_PROFILE_EMPLOYEE_NOTES',
} as const;

export const PerformanceScoreLevelQueryKey = {
    PERFORMANCE_SCORE_LEVELS: 'PERFORMANCE_SCORE_LEVELS',
    PERFORMANCE_SCORE_LEVEL_DELETION_IMPACT: 'PERFORMANCE_SCORE_LEVEL_DELETION_IMPACT',
} as const;

export const PerformanceScoreLevelMutationKey = {
    REPLACE_PERFORMANCE_SCORE_LEVELS: 'REPLACE_PERFORMANCE_SCORE_LEVELS',
    DELETE_PERFORMANCE_SCORE_LEVEL: 'DELETE_PERFORMANCE_SCORE_LEVEL',
} as const;

export const ObjectiveQueryKey = {
    OBJECTIVES: 'OBJECTIVES',
    OBJECTIVE: 'OBJECTIVE',
    /** Company-wide pillar summaries: the only reading of the pillars, whatever the screen. */
    COMPANY_PILLAR_SUMMARIES: 'COMPANY_PILLAR_SUMMARIES',
    COMPANY_PILLAR_SUMMARY: 'COMPANY_PILLAR_SUMMARY',
    OBJECTIVE_COMMENTS: 'OBJECTIVE_COMMENTS',
    EMPLOYEES_WITHOUT_OBJECTIVES: 'EMPLOYEES_WITHOUT_OBJECTIVES',
    FILTERED_EMPLOYEES: 'FILTERED_EMPLOYEES',
    PARTICIPANT_ATTRIBUTES_RESOLUTION: 'PARTICIPANT_ATTRIBUTES_RESOLUTION',
    CHOOSABLE_TEAM_MANAGERS: 'CHOOSABLE_TEAM_MANAGERS',
} as const;

export const ObjectiveMutationKey = {
    CREATE_OBJECTIVE: 'CREATE_OBJECTIVE',
    CREATE_OBJECTIVE_COMMENT: 'CREATE_OBJECTIVE_COMMENT',
    UPDATE_OBJECTIVE: 'UPDATE_OBJECTIVE',
    DELETE_OBJECTIVE: 'DELETE_OBJECTIVE',
    UPDATE_KEY_RESULT_PROGRESS: 'UPDATE_KEY_RESULT_PROGRESS',
} as const;

export const ObjectivePeriodQueryKey = {
    OBJECTIVE_PERIODS: 'OBJECTIVE_PERIODS',
    OBJECTIVE_PERIOD: 'OBJECTIVE_PERIOD',
} as const;

export const ObjectivePeriodMutationKey = {
    CREATE_OBJECTIVE_PERIOD: 'CREATE_OBJECTIVE_PERIOD',
    UPDATE_OBJECTIVE_PERIOD: 'UPDATE_OBJECTIVE_PERIOD',
    SET_OBJECTIVE_PERIOD_STATUS: 'SET_OBJECTIVE_PERIOD_STATUS',
    DELETE_OBJECTIVE_PERIOD: 'DELETE_OBJECTIVE_PERIOD',
} as const;

export const PerformanceProfileMutationKey = {
    ADD_ADDITIONAL_COMPETENCIES: 'ADD_ADDITIONAL_COMPETENCIES',
    REMOVE_ADDITIONAL_COMPETENCY: 'REMOVE_ADDITIONAL_COMPETENCY',
    ADD_EXCLUDED_COMPETENCY: 'ADD_EXCLUDED_COMPETENCY',
    REMOVE_EXCLUDED_COMPETENCY: 'REMOVE_EXCLUDED_COMPETENCY',
    SELF_ASSESSMENTS: 'SELF_ASSESSMENTS',
    EVALUATION_360: 'EVALUATION_360',
    MANAGER_ASSESSMENTS: 'MANAGER_ASSESSMENTS',
    UPDATE_SKILL_PROFICIENCY: 'UPDATE_SKILL_PROFICIENCY',
    CREATE_CAREER_STEP: 'CREATE_CAREER_STEP',
    UPDATE_CAREER_STEP: 'UPDATE_CAREER_STEP',
    DELETE_CAREER_STEP: 'DELETE_CAREER_STEP',
    CREATE_CAREER_ASPIRATION: 'CREATE_CAREER_ASPIRATION',
    UPDATE_CAREER_ASPIRATION: 'UPDATE_CAREER_ASPIRATION',
    CREATE_EMPLOYEE_NOTE: 'CREATE_EMPLOYEE_NOTE',
    UPDATE_EMPLOYEE_NOTE: 'UPDATE_EMPLOYEE_NOTE',
    DELETE_EMPLOYEE_NOTE: 'DELETE_EMPLOYEE_NOTE',
} as const;

export const ThematicMeetingQueryKey = {
    THEMATIC_MEETINGS: 'THEMATIC_MEETINGS',
    THEMATIC_MEETING: 'THEMATIC_MEETING',
    THEMATIC_MEETING_PLAN: 'THEMATIC_MEETING_PLAN',
    THEMATIC_MEETING_STATS: 'THEMATIC_MEETING_STATS',
    OVERDUE_EMPLOYEES: 'OVERDUE_EMPLOYEES',
    EDITABLE_MEETING_TEMPLATES: 'EDITABLE_MEETING_TEMPLATES',
    MEETING_TEMPLATES: 'MEETING_TEMPLATES',
    MEETING_TEMPLATE_CATALOG: 'MEETING_TEMPLATE_CATALOG',
    THEMATIC_MEETING_TRANSCRIPT: 'THEMATIC_MEETING_TRANSCRIPT',
    THEMATIC_MEETING_CALENDAR_LINKS: 'THEMATIC_MEETING_CALENDAR_LINKS',
} as const;

/** The cache key of one meeting. */
export const thematicMeetingKey = (id: string) => [ThematicMeetingQueryKey.THEMATIC_MEETING, id];

/** The cache key of the plan one meeting follows. */
export const thematicMeetingPlanKey = (meetingId: string) => [
    ThematicMeetingQueryKey.THEMATIC_MEETING_PLAN,
    meetingId,
];

/** The cache key of a meeting's transcript and recap. */
export const thematicMeetingTranscriptKey = (meetingId: string | undefined) => [
    ThematicMeetingQueryKey.THEMATIC_MEETING_TRANSCRIPT,
    meetingId,
];

export const ThematicMeetingMutationKey = {
    CREATE_THEMATIC_MEETING: 'CREATE_THEMATIC_MEETING',
    UPDATE_THEMATIC_MEETING_SCHEDULE: 'UPDATE_THEMATIC_MEETING_SCHEDULE',
    UPDATE_THEMATIC_MEETING_CONTEXT: 'UPDATE_THEMATIC_MEETING_CONTEXT',
    UPDATE_THEMATIC_MEETING_PREPARATION_NOTES: 'UPDATE_THEMATIC_MEETING_PREPARATION_NOTES',
    DELETE_THEMATIC_MEETING: 'DELETE_THEMATIC_MEETING',
    COMPLETE_THEMATIC_MEETING: 'COMPLETE_THEMATIC_MEETING',
    REOPEN_THEMATIC_MEETING: 'REOPEN_THEMATIC_MEETING',
    UPDATE_THEMATIC_MEETING_AGENDA: 'UPDATE_THEMATIC_MEETING_AGENDA',
    UPDATE_THEMATIC_MEETING_TITLE: 'UPDATE_THEMATIC_MEETING_TITLE',
    DOWNLOAD_THEMATIC_MEETING_CALENDAR: 'DOWNLOAD_THEMATIC_MEETING_CALENDAR',
    UPLOAD_THEMATIC_MEETING_TRANSCRIPT: 'UPLOAD_THEMATIC_MEETING_TRANSCRIPT',
    UPDATE_MEETING_TEMPLATE: 'UPDATE_MEETING_TEMPLATE',
    CREATE_MEETING_TEMPLATE: 'CREATE_MEETING_TEMPLATE',
    IMPORT_MEETING_TEMPLATE: 'IMPORT_MEETING_TEMPLATE',
} as const;

export const ReportQueryKey = {
    COMPETENCY_MATRIX: 'COMPETENCY_MATRIX',
} as const;

export const CalibrationQueryKey = {
    CYCLES: 'CALIBRATION_CYCLES',
    REPORT: 'CALIBRATION_REPORT',
} as const;

export const CompensationQueryKey = {
    CYCLES: 'COMPENSATION_CYCLES',
    CYCLE_OVERVIEW: 'COMPENSATION_CYCLE_OVERVIEW',
    ENVELOPE: 'COMPENSATION_ENVELOPE',
    PREVIEW: 'COMPENSATION_PREVIEW',
    VERSIONS: 'COMPENSATION_VERSIONS',
} as const;

export const CompensationMutationKey = {
    SAVE: 'COMPENSATION_SAVE',
    PARSE_SALARIES: 'COMPENSATION_PARSE_SALARIES',
    EXPORT: 'COMPENSATION_EXPORT',
} as const;

export const EmployeePortalQueryKey = {
    RECOGNITIONS: 'EMPLOYEE_PORTAL_RECOGNITIONS',
} as const;
